import React from "react";
import "./CheckoutPaymentFooter.css";
import {
  SecureCheckoutIcons,
  SecureCheckoutIconsMobile,
} from "../../../../Assets/svgs";

const CheckoutPaymentFooter = () => {
  return (
    <div className="payment-footer">
      <img
        src={SecureCheckoutIcons}
        alt="secure-checkout-icons"
        className="secure-checkout-icons"
      />
      <img
        src={SecureCheckoutIconsMobile}
        alt="secure-checkout-icons-mobile"
        className="secure-checkout-icons-mobile"
      />
    </div>
  );
};

export default CheckoutPaymentFooter;
